var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97748 0.428629C10.0002 0.371839 10.0058 0.309626 9.99348 0.249703C9.98119 0.189781 9.95158 0.134783 9.90833 0.0915293C9.86508 0.0482752 9.81008 0.0186668 9.75016 0.0063746C9.69023 -0.00591756 9.62802 -0.000352871 9.57123 0.0223788L0.479355 3.65925H0.47873L0.19623 3.77175C0.142724 3.7931 0.0961588 3.82881 0.0616776 3.87496C0.0271964 3.92111 0.00614157 3.97589 0.000838731 4.03325C-0.00446411 4.09061 0.00619147 4.14832 0.0316284 4.2C0.0570654 4.25169 0.0962938 4.29534 0.14498 4.32613L0.40123 4.48863L0.401855 4.48988L3.52373 6.47613L5.50998 9.598L5.51123 9.59925L5.67373 9.8555C5.70462 9.904 5.74829 9.94304 5.79994 9.96832C5.85159 9.99359 5.90921 10.0041 5.96646 9.99876C6.02371 9.9934 6.07837 9.97235 6.12442 9.93792C6.17047 9.90349 6.20614 9.85702 6.22748 9.80363L9.97748 0.428629ZM8.83185 1.60988L4.14811 6.29363L4.01373 6.08238C3.98911 6.04361 3.95625 6.01075 3.91748 5.98613L3.70623 5.85175L8.38998 1.168L9.12623 0.873629L8.83185 1.60988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.dce7d9180b7a84a5714c2631351df07f.svg";
export { ForwardRef as ReactComponent };